import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledDropdownLabel = styled.span.attrs<{ "data-automation"?: string }>((props) => ({
    "data-automation": "dropdown-label-text",
}))`
    ${setFontVariant("h6", colorsPalettes.carbon["400"])};
    white-space: nowrap;
    user-select: none;
`;
